import api from "../../../api/api";

/** Disclosure */
export const listDisclosures = (params) => api.get("/disclosure", { params });

export const getDisclosureById = (d_id) =>
  api.get(`/disclosure/${encodeURIComponent(d_id)}`);

export const createDisclosure = (body) => api.post("/disclosure", body);

export const updateDisclosure = (d_id, body) =>
  api.put(`/disclosure/${encodeURIComponent(d_id)}`, body);

export const deleteDisclosure = (d_id) =>
  api.delete(`/disclosure/${encodeURIComponent(d_id)}`);

/** Body: { items: [...], c_id? } — matches POST /disclosure/batch-sync */
export const batchSyncDisclosures = (body) =>
  api.post("/disclosure/batch-sync", body);

/** Body: { d_ids: string[] } — matches POST /disclosure/batch-delete */
export const deleteDisclosuresBatch = (d_ids) =>
  api.post("/disclosure/batch-delete", { d_ids });

/** DisclosureTag */
export const listDisclosureTags = (params) =>
  api.get("/disclosure/tags", { params });

export const getDisclosureTagById = (t_id) =>
  api.get(`/disclosure/tags/${encodeURIComponent(t_id)}`);

export const createDisclosureTag = (body) => api.post("/disclosure/tags", body);

export const updateDisclosureTag = (t_id, body) =>
  api.put(`/disclosure/tags/${encodeURIComponent(t_id)}`, body);

export const deleteDisclosureTag = (t_id) =>
  api.delete(`/disclosure/tags/${encodeURIComponent(t_id)}`);

/** Body: { t_ids: string[] } — POST /disclosure/tags/batch-delete */
export const deleteDisclosureTagsBatch = (t_ids) =>
  api.post("/disclosure/tags/batch-delete", { t_ids });
